module.exports = __webpack_public_path__ + "img/icon_down.0904d239.svg";